import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Exam } from '../Common/types';
import { FiTrash, FiEdit } from "react-icons/fi";
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";
import { useTenant } from "../Routers/TenantContextProvider";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}

const TutorExams = () => {
  const [exams, setExams] = useState<Exam[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const navigate = useNavigate();

  const { tenant, loading, error } = useTenant();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  // Set tenant ID on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token);
      console.log("Tenant ID:", tenantId);
      setSelectedTenant(tenantId);
    }
  }, []);

  // Fetch exams when tenant ID is set
  useEffect(() => {
    if (selectedTenant) {
      fetchTutorExams();
    }
  }, [selectedTenant]);

  const fetchTutorExams = async () => {
    if (!selectedTenant) return;
    try {
     const api = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const response = await axios.get(`${api}/tutor/exams/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setExams(response.data);
    } catch (error) {
      console.error("Failed to load exams", error);
    }
  };

  const handleReviewExam = (exam_id: number) => {
    // Placeholder function
   // navigate(`/coaching/tutor/dashboard/tutor-exams/evaluate-exam-by-tutor/${exam_id}`);
    if (tenant)
    {
      navigate(`/platform/${tenant.tenant_slug}/app/tutor-exams/evaluate-exam-by-tutor/${exam_id}`);
    }
  };

  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Exams</Heading>
      </VStack>
      <Box mt={4}>
        <Text fontWeight="bold">Exams Details</Text>
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Title</Th>
              <Th>Status</Th>
              <Th>Published At</Th>
              <Th>Start Time</Th>
              <Th>End Time</Th>
              <Th>Updated At</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
            {exams.map((exam) => (
              <Tr key={exam.exam_id}>
                <Td>{exam.exam_id}</Td>
                <Td>{`${exam.title}`}</Td>
                <Td>{`${exam.status}`}</Td>
                    <Td>
                      {exam.published_at ? fmtLocal(exam.published_at, { hour: undefined, minute: undefined }) : 'N/A'}
                    </Td>

                <Td>{fmtLocal(exam.start_time)}</Td>
                <Td>{fmtLocal(exam.end_time)}</Td>
                <Td>{fmtLocal(exam.updated_at)}</Td>
                
                <Td>
                  <Tooltip label="Edit">
                    <Button size="sm" onClick={() => handleReviewExam(exam.exam_id)}  mr={8}>
                        Evaluate Manual Attempts
                        </Button>
                  </Tooltip>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default TutorExams;
